module.exports = __webpack_public_path__ + "static/img/c301.560f8a99.png";